var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._l((_vm.grade),function(item,index){return _c('span',{key:index,staticClass:"icon",class:item})}),_vm._v(" "),_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm.percent)+"%")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }